/**
 * Whether a histogram bin's middle lies in the target band [targetMin, targetMax] (B6): either end may be absent (a
 * floor or a ceiling); with neither, there is no band and no bin is outside it. Pure.
 */
export function inBand(mid: number, targetMin: number | undefined, targetMax: number | undefined): boolean {
  return (targetMin === undefined || mid >= targetMin) && (targetMax === undefined || mid <= targetMax);
}
